import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ReleaseNotesData } from "./release-note-data";

@customElement("release-notes")
export class ReleaseNotes extends LitElement {
  @property({ type: Boolean }) _show: boolean[] = [false];

  static get styles() {
    return [
      css`
        .inner-container {
          max-height: 400px;
          font-family: MaerskText;
          font-size: 14px;
        }

        .title {
          font-weight: 600;
        }

        .page-title {
          font-family: MaerskText;
          font-size: 20px;
          font-weight: 700;
          text-align: center;
          margin-top: -16px;
        }

        .history-list {
          text-decoration: underline;
          cursor: pointer;
          color: blue;
        }

        .history {
          margin-left: -16px;
        }

        .history-details {
          margin-left: -24px;
        }

        .history-title{
          font-size: 14px;
          font-weight: 600;
        }
      `,
    ];
  }

  private _renderReleaseHistory = () => {
    return html` <ul class="history">
        ${ReleaseNotesData.map((releaseNote, index) => {
          if (index !== 0)
            return html`
              <li
                @click=${() => {
                  this._show[index] = !this._show[index];
                  this.requestUpdate();
                }}
                class="history-list"
              >
                v:${releaseNote.version} (${releaseNote.releaseData})
              </li>
              ${this._show[index]
                ? html`<div class="history-details">${this._renderReleaseNotes(releaseNote)}</div>`
                : html``}
            `;
        })}
      </ul>
      <br />`;
  };

  private _renderReleaseNotes(releaseNote: any) {
    return html`
      <h3>${releaseNote.releaseData}</h3>
      <p class="version-details">
        <em>Fleet Voyage version: ${releaseNote.version}</em>
      </p>
      ${releaseNote.newFeatures ? html`<h4>New Features:</h4>`: html``}
      <ul>
        ${releaseNote.newFeatures?.map((feature: any) => {
          return html`<li>
            <p>
              <span class="title">${feature.title}:</span>
              <span> ${feature.description}</span>
            </p>
          </li>`;
        })}
      </ul>
      ${releaseNote.bugFixes ? html`<h4>Bug Fixes:</h4>`: html``}
      <ul>
        ${releaseNote.bugFixes?.map((bug: any) => {
          return html`<li>
            <p>
              <span class="title">${bug.title}: </span
              ><span> ${bug.description}</span>
            </p>
          </li>`;
        })}
      </ul>
    `;
  }

  render() {
    return html` <h2 class="page-title">Fleet Voyage - Release Notes</h2>
      <div class="inner-container">
        ${ReleaseNotesData.map((releaseNote, index) => {
          if (index === 0) return this._renderReleaseNotes(releaseNote);
         
        })}
        <div class="history-title">Release Archives: A Journey Through Past Updates</div>
        ${this._renderReleaseHistory()}
      </div>`;
  }
}
